<template>
  <basic-form
    ref="shipmentInfo"
    title="Shipment Info"
    :mode="mode"
    :form-params="whatToShow"
  >
    <template v-slot:actions>
      <el-button
        size="mini"
        type="primary"
        :disabled="shipmentStatus === ShipmentDeleted"
        plain
        @click="editing = true"
        v-if="!editing && editable"
      >
        Edit
      </el-button>
      <el-button
        size="mini"
        type="primary"
        plain
        @click="saveInfo"
        v-if="editing && editable"
      >
        Save
      </el-button>
      <el-button
        size="mini"
        type="danger"
        plain
        @click="editing = false"
        v-if="editing && editable"
      >
        Cancel
      </el-button>
    </template>
  </basic-form>
</template>
<script>
// components
import BasicForm from '@/components/common/BasicForm.vue'
// model
import {
  ShipmentDeleted,
  ShipmentInfoModifyForm,
  ShipmentBasicWrapUp
} from '@/core/models/shipment'
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// apis
import { modifyShipment } from '@/api/shipment'
// msg
import PagesMessage from '@/core/message/pages'
export default {
  name: 'ShipmentInfo',
  components: { BasicForm },
  props: {
    shipmentNo: {
      type: String,
      required: true
    },
    shipment: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    },
    checkDetail: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  data() {
    return {
      ShipmentDeleted,
      editing: false
    }
  },
  methods: {
    saveInfo() {
      const [passed, values] = this.$refs.shipmentInfo.validateAllInputs()
      if (passed) {
        this.$confirm('Update Shipment Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          modifyShipment(this.shipment.id, values).then(res => {
            this.editing = false
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
          })
        })
      }
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return ShipmentBasicWrapUp(this.shipment)
    },
    editInfo() {
      const form = cloneDeep(ShipmentInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.shipment[one.key]
      })
      return form
    },
    shipmentStatus() {
      return this.shipment?.status ?? null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
